import styled from 'styled-components'
import { colours, shadows } from '@qflow/theme'

export const Container = styled.div<{ $visible: boolean }>`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-content: center;
  align-items: center;
  gap: 0.5rem;
  position: absolute;
  left: 0;
  right: 0;

  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  top: ${({ $visible }) => ($visible ? 1 : 0)}rem;
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};

  transition: 300ms all ease-in-out;
  transition-property: opacity, top;
`
export const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-content: start;
  align-items: center;
  border-radius: 6px;
  padding: 10px;

  background-color: ${colours.WHITE};
  z-index: 10;

  ${shadows.MID}
`
export const ActionStripCard = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 2px 0;
  width: 100%;
  min-width: 640px;

  & button:focus {
    outline: none;
  }

  & button.selected {
    color: #fff;
    background-color: ${colours.CORE_NAVY};
  }
`

export const ActionStripButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  min-width: 440px;
`
export const ActionStripButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
`

export const StyledUpdateSection = styled.div`
  padding: 1rem;
  background-color: ${colours.CONTROL_PANEL_GREY};
  border-radius: 8px;
  margin: 1rem 0 0.5rem 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
  max-width: 542px;

  h3 {
    margin: 0;
    font-size: 0.875rem;
    font-weight: 600;
  }
`

export const TagInputContainer = styled.div`
  width: 100%;
`

export const UntaggingTagList = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding: 0.5rem;
  background-color: ${colours.WHITE};
  border-radius: 0.5rem;
  border: 1px solid ${colours.LIGHT_GREY};
`

export const UntaggingTagButton = styled.button<{ $selected: boolean }>`
  border: none;
  border-radius: 0.25rem;
  padding: 0.2rem 0.5rem;
  cursor: pointer;
  font-size: 0.8rem;
  transition:
    background-color 120ms ease-in-out,
    color 120ms ease-in-out;

  background-color: ${({ $selected }) =>
    $selected ? colours.AMBER_BACKGROUND : colours.PALE_TEAL};
  color: ${({ $selected }) =>
    $selected ? colours.ORANGE_TEXT : colours.CORE_NAVY};

  &:hover {
    background-color: ${({ $selected }) =>
      $selected ? colours.AMBER_BACKGROUND : colours.LIGHT_TEAL};
  }
`

export const NoTagsMessage = styled.div`
  width: 100%;
  padding: 0.75rem 0.5rem;
`

export const ApplyButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  padding: 0.5rem 0 0 0;
`
